module.exports = __webpack_public_path__ + "static/media/next_icon.964620c9.svg";